// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"6dd1abe1","553":"c0da47b4"}[chunkId] + ".chunk.js";
};